const initBlock = async function( $block ) {
	const TestimonialsSliderModule = await import( '../modules/testimonials' );
	const TestimonialsSlider = TestimonialsSliderModule.default;
	new TestimonialsSlider( $block );
};

themeUtils.loadBlock( initBlock, 'testimonials', '.section-testimonials' );
